/* eslint-disable */
export default {
  confirmation: 'Confirmación',
  confirmMergeToConference: '¿Añadir a la llamada de conferencia?',
  mergeToConference: 'Combinar',
  conferenceCall: 'Llamada de conferencia',
} as const;

// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
